export const NODE_IMPORTANCE_OPTIONS = [
  { value: "focal", label: "Focal", description: "The map's primary organizing concept" },
  { value: "core", label: "Core", description: "Essential to understanding the map" },
  { value: "supporting", label: "Supporting", description: "Develops or connects central ideas" },
  { value: "detail", label: "Detail", description: "Evidence, examples, or finer-grained context" },
];

export const NODE_ICON_GROUPS = [
  { label: "General", options: [
    ["none", "No icon"], ["star", "Featured"], ["idea", "Idea"],
    ["target", "Goal"], ["sparkles", "New possibility"], ["flag", "Milestone"],
  ] },
  { label: "Knowledge and evidence", options: [
    ["book", "Knowledge"], ["education", "Education"], ["research", "Research"],
    ["evidence", "Evidence"], ["document", "Document"], ["quote", "Quotation"],
    ["search", "Inquiry"], ["source", "Source or link"],
  ] },
  { label: "People and society", options: [
    ["person", "Person"], ["people", "People"], ["community", "Community"],
    ["care", "Care"], ["handshake", "Partnership"], ["conversation", "Dialogue"],
    ["network", "Network"],
  ] },
  { label: "Places and organizations", options: [
    ["world", "World"], ["organization", "Organization"], ["institution", "Institution"],
    ["home", "Home or community"], ["place", "Place"], ["industry", "Industry"],
  ] },
  { label: "Work and systems", options: [
    ["practice", "Practice"], ["settings", "System or process"], ["technology", "Technology"],
    ["code", "Code"], ["finance", "Finance"], ["balance", "Law or balance"],
    ["policy", "Policy"], ["puzzle", "Component"],
  ] },
  { label: "Nature, health, and change", options: [
    ["environment", "Environment"], ["tree", "Ecology"], ["water", "Water"],
    ["health", "Health"], ["energy", "Energy"], ["food", "Food"],
    ["success", "Success"], ["warning", "Risk or warning"], ["growth", "Growth"],
    ["time", "Time"], ["protection", "Protection"],
  ] },
];

export const NODE_ICON_OPTIONS = NODE_ICON_GROUPS.flatMap((group) => group.options);

const IMPORTANCE = new Set(NODE_IMPORTANCE_OPTIONS.map((item) => item.value));
const ICONS = new Set(NODE_ICON_OPTIONS.map(([value]) => value));

export function normalizeNodeImportance(value, isCore = false) {
  return IMPORTANCE.has(value) ? value : (isCore ? "core" : "supporting");
}

export function normalizeNodeIcon(value) {
  return ICONS.has(value) ? value : "none";
}

export function normalizeNodeResources(resources) {
  if (!Array.isArray(resources)) return [];
  const seen = new Set();
  return resources.slice(0, 12).flatMap((resource) => {
    const title = String(resource?.title || "").trim().slice(0, 160);
    const url = String(resource?.url || "").trim().slice(0, 2048);
    try {
      const parsed = new URL(url);
      if (!["http:", "https:"].includes(parsed.protocol) || seen.has(url.toLowerCase())) return [];
      seen.add(url.toLowerCase());
      return [{ title: title || parsed.hostname, url }];
    } catch {
      return [];
    }
  });
}

/** Validate drafts before normalization so incomplete references are not silently dropped. */
export function nodeResourceErrors(resources) {
  const seen = new Set();
  return resources.map(resource => {
    const url = String(resource?.url || "").trim();
    if (!url) return String(resource?.title || "").trim() ? "Enter a URL or remove this link." : "";
    try {
      const parsed = new URL(url);
      if (!["http:", "https:"].includes(parsed.protocol)) return "Use a URL beginning with http:// or https://.";
      if (seen.has(url.toLowerCase())) return "This URL is already listed on this node.";
      seen.add(url.toLowerCase());
      return "";
    } catch { return "Use a complete URL beginning with http:// or https://."; }
  });
}
